export type FormFieldSourceType = "global" | "local";

export interface FormFieldSourceOption {
    id: string;
    sourceType: FormFieldSourceType;
    systemName: string;
    visibleDescription: string;
    sourceValues: Record<string, unknown>;
    disabled?: boolean;
}

export const getFormFieldSourceKey = (sourceType: FormFieldSourceType, id: string) => `${sourceType}:${id}`;
